import { trackRegistrationConversion } from '@repo/analytics/google-site-tag'
import { facebookEvent, FacebookEventName } from '@repo/analytics/facebook'
import { bingEvent, BingEventName } from '@repo/analytics/bing'
import { localStore } from 'utils/storage'

// oxlint-disable-next-line require-await
export async function trackRegistration({
  isGAdsSignup,
  isNew,
  userId,
}: {
  isGAdsSignup: boolean
  isNew: boolean
  userId: string
}) {
  if (isGAdsSignup) {
    trackRegistrationConversion()
  }

  if (isNew) {
    facebookEvent(FacebookEventName.COMPLETE_REGISTRATION)
    bingEvent(BingEventName.COMPLETE_REGISTRATION, {
      event_category: 'user',
      event_label: userId,
    })
  }
}

const LAST_USED_LOGIN_METHOD_KEY = 'cf-last-used-login-method'

export function saveLastUsedMethod(method: string) {
  localStore.setString(LAST_USED_LOGIN_METHOD_KEY, method)
}

export function getLastUsedMethod() {
  return localStore.getString(LAST_USED_LOGIN_METHOD_KEY)
}
